import React, { Component } from 'react';
import {
  Form, Input, Button, Modal, Upload, Icon, message, Select
} from 'antd';
import constants from '../../constants';

import 'antd/dist/antd.css';

const Option = Select.Option;


function handleChange(value) {
  console.log(`selected ${value}`);
}

function handleBlur() {
  console.log('blur');
}

function handleFocus() {
  console.log('focus');
}
class MachineDiagramsAddView extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.beforeUploadFile = this.beforeUploadFile.bind(this);
    // this.normFile = this.normFile.bind(this);
    // this.updateFiles = this.updateFiles.bind(this);
    this.state = {
      visible: false,
      fileList: [],
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    // console.log(e);
    this.props.form.validateFields((err, values) => {
      console.log("snkgjhdfjkg");
      if (!err) {
        this.props.handleSubmit(values, this.state.fileList[0]);
        this.props.form.resetFields();
      }
    });
  }

  // beforeUploadFile(file) {
  //     // const isJPG = file.type === 'image/jpeg';
  //     // if (!isJPG) {
  //     //     message.error('You can only upload JPG file!');
  //     // }
  //     const isLt2M = file.size / 1024 / 1024 < 2;
  //     message.error('Image must smaller than 2MB!');
  //     if (!isLt2M) {
  //         message.error('Image must smaller than 2MB!');
  //     }
  //     return isLt2M;
  // }

  updateFiles(info) {
    this.setState({
      files: this.state.files.concat(info),
    })
    return true;
  }

  normFile(e) {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && this.state.fileList;
  }


  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  }

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    const { getFieldDecorator } = this.props.form;

    const uploadFileProps = {
      action: '//jsonplaceholder.typicode.com/posts/',
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          message.error('File must smaller than 10MB!');
        } else {
          this.setState(({ fileList }) => ({
            fileList: [file],
          }));
        }
        return false;
      },
      fileList: this.state.fileList,
    };
    const button = <Button type="primary lg col-md-4 center-block" onClick={this.showModal}>Add Diagrams</Button>;
    return (
      <div>
        {this.props.extraUser.type === constants.ADMIN_ROLE && button}
        {this.props.extraUser.type === constants.SADMIN_ROLE && button}
        {this.props.extraUser.type === constants.TEC_ROLE && button}
        {this.props.extraUser.type === constants.SUPV_ROLE && button}
          
        <Modal
          title="Add Diagrams"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Form onSubmit={this.handleSubmit}>
            <Form.Item
                {...formItemLayout}
                label="Type"
            >
                {getFieldDecorator('type', {
                    rules: [{ required: true, message: 'Select Type' }],
                })(
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Select Type"
                        optionFilterProp="children"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        filterOption={(input, option) => option.props.children.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0}
                    >
                        <Option value="Electric">
                            Electric
                        </Option>
                        <Option value="Book of Parts">
                            Book Of Parts
                        </Option>
                        <Option value="Neumatico">
                            Neumático
                        </Option>
                        <Option value="Manuals">
                            Manuals
                        </Option>
                    </Select>,
                )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Brand"
            >
              {getFieldDecorator('brand', {
                rules: [{ required: true, message: 'Insert Brand' }],
              })(
                <Input />,
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Detail"
            >
              {getFieldDecorator('details', {
                rules: [{ required: true, message: 'Insert Detail' }],
              })(
                <Input.TextArea rows={4} />,
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="File"
            >
              {getFieldDecorator('file', {
                // getValueFromEvent: this.normFile,
              })(
                <Upload
                  // name="file"
                  // listType="picture-card"
                  // className="avatar-uploader"
                  // showUploadList={true}
                  // beforeUpload={this.beforeUploadPicture}
                  // onChange={this.updateFiles}
                  // action="//jsonplaceholder.typicode.com/posts/"
                  {...uploadFileProps}
                >
                  <Button>
                    <Icon type="upload" /> Click to upload
                                </Button>
                </Upload>,
              )}
            </Form.Item>


            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit" onClick={this.handleOk} >
                Save
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(MachineDiagramsAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineDiagramsAddView.js